import { useSyncExternalStore } from "react";
import {
  getOpenedEnquiries,
  subscribeToOpenedEnquiries,
} from "../openedEnquiries";

/**
 * The enquiries this browser has already opened, as a set to test a row's id
 * against — anything not in it is new, and wears the tag.
 *
 * Subscribed rather than read once: opening an enquiry in this sitting has to
 * take the tag off the list behind it and one off the rail's count, and both
 * are drawn from the same store. See `openedEnquiries`.
 */
export function useOpenedEnquiries(): ReadonlySet<string> {
  return useSyncExternalStore(
    subscribeToOpenedEnquiries,
    getOpenedEnquiries,
    getOpenedEnquiries
  );
}

export default useOpenedEnquiries;
